import React, { useContext } from 'react';
import { t, defineMessages } from '@sm/intl';
import { getHelpCenterLink, StaticContext } from '@sm/webassets';
import { createURL } from '@sm/utils';
import { BottomBar } from '../../BottomBar';
import {
  BottomBarCtaColors,
  BottomBarCtaVariants,
  BottomBarThemes,
} from '../../BottomBarEnums';
import './automatic-insights.scss';

const COPY = defineMessages({
  MESSAGE: {
    id: 'AutomaticInsightsBottomBar.message',
    defaultMessage:
      "<a href='{ automaticInsightsLink }' target='_blank' class='sm-bottom-bar__insights'>Automatic Insights</a> is now available in your account. This setting includes any feature that uses machine learning to process your survey and serve up insights for you. You can always change your preferences in <a href='{ myAccountLink }' target='_blank' class='sm-bottom-bar__my-account'>My Account</a>.",
    description: '[Type: Paragraph][Vis.: low] - Bottom bar message',
  },
  CTA_TEXT: {
    id: 'AutomaticInsightsBottomBar.ctaText',
    defaultMessage: 'ENABLE',
    description: '[Type: Button][Vis.: low] - Bottom bar cta text',
  },
});

export const AutomaticInsightsBottomBar: React.FC = () => {
  const {
    user: { languageCode },
  } = useContext(StaticContext);

  const automaticInsightsLink = getHelpCenterLink(languageCode, {
    path: 'policy/automatic-insights',
    params: {
      ut_source: 'bottombar',
      ut_source2: 'automatic_insights_opt_in',
    },
  });
  const myAccountLink = createURL('/user/account/', {
    ut_source: 'bottombar',
    ut_source2: 'automatic_insights_opt_in',
  });

  return (
    <BottomBar
      message={t(
        COPY.MESSAGE,
        { automaticInsightsLink, myAccountLink },
        { html: true }
      )}
      ctaText={t(COPY.CTA_TEXT)}
      // TODO: update when the insights enabled endpoint is available.
      // See https://jira.surveymonkey.com/browse/IG-1467.
      ctaLink="/"
      ctaColor={BottomBarCtaColors.ghost}
      ctaVariant={BottomBarCtaVariants.ghost}
      theme={BottomBarThemes.charcoal}
      dismissable
    />
  );
};

export default AutomaticInsightsBottomBar;
